import Grid from '@mui/material/Grid';
import useTheme from '@mui/material/styles/useTheme';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface LegendItemProps {
  color: string;
  label: string;
  status: number;
  hidden: boolean;
  onToggle: (status: number) => void;

}

const LegendItem: React.FC<LegendItemProps> = ({ color, label, status, hidden, onToggle }) => (
  <Grid item sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => onToggle(status)}>
    <div
      style={{
        width: 16,
        height: 16,
        borderRadius: '50%',
        backgroundColor: color,
        border: "1px solid black",
        marginRight: 8,
      }}
    ></div>
    <Typography variant="body2" color={hidden ? "#ccc" : "black"}>{label}</Typography>
  </Grid>
);

interface TellTalesLegendProps {
  onToggleStatus: (status: number) => void;
  hiddenStatuses: number[];
}


export default function TellTalesLegend({ onToggleStatus, hiddenStatuses }: TellTalesLegendProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Grid container spacing={2}>
      <LegendItem
        color={theme.palette.grey[400]}
        label="N/A"
        status={7}
        hidden={hiddenStatuses.includes(7)}
        onToggle={onToggleStatus}
      />
      <LegendItem
        color="white"
        label={t("faultOverview.available")}
        status={0}
        hidden={hiddenStatuses.includes(0)}
        onToggle={onToggleStatus}
      />
      <LegendItem
        color={theme.palette.warning.main}
        label={t("faultOverview.warning")}
        status={2}
        hidden={hiddenStatuses.includes(2)}
        onToggle={onToggleStatus}
      />
      <LegendItem
        color={theme.palette.error.main}
        label={t("faultOverview.error")}
        status={1}
        hidden={hiddenStatuses.includes(1)}
        onToggle={onToggleStatus}
      />
      <LegendItem
        color={theme.palette.primary.main}
        label={t("faultOverview.information")}
        status={3}
        hidden={hiddenStatuses.includes(3)}
        onToggle={onToggleStatus}
      />
    </Grid>
  );
}

